import { X } from "lucide-react";
import { RoleSummary } from "../../../../shared/api/roles";
import { cn } from "../../../../shared/lib";
import {
  Button,
  Checkbox,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "../../../../shared/ui";

type RolesSelectionModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  roles: RoleSummary[];
  selectedRoles: string[];
  onToggleRoleSelection: (roleName: string) => void;
  className?: string;
};

const RolesSelectionModal = ({
  open,
  onOpenChange,
  roles,
  selectedRoles,
  onToggleRoleSelection,
  className,
}: RolesSelectionModalProps) => {
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      className={cn(className)}
      contentClassName="max-w-[600px]"
    >
      <ModalHeader>
        <ModalTitle>Select role(s)</ModalTitle>
        <button
          type="button"
          aria-label="Close role selector"
          className="rounded-full p-2 text-[#737AA8] hover:bg-[#F2F4FF]"
          onClick={() => onOpenChange(false)}
        >
          <X size={20} />
        </button>
      </ModalHeader>

      <ModalBody className="max-h-[55vh] space-y-3 overflow-y-auto py-4">
        {roles.length === 0 ? (
          <div className="rounded-[16px] border border-dashed border-[#D7DCF0] p-6 text-center text-[14px] text-[#6B6F8A]">
            No roles available yet.
          </div>
        ) : (
          roles.map((roleItem) => {
            const isSelected = selectedRoles.includes(roleItem.name);
            return (
              <button
                key={roleItem.id}
                type="button"
                className="flex w-full items-center gap-4 rounded-[16px] border border-[#E1E6FF] bg-white px-4 py-4 text-left transition-colors hover:bg-[#F7F8FD]"
                onClick={() => onToggleRoleSelection(roleItem.name)}
              >
                <Checkbox
                  checked={isSelected}
                  onChange={() => onToggleRoleSelection(roleItem.name)}
                  className="shrink-0"
                  size="sm"
                />
                <div>
                  <div className="text-[16px] font-[600] text-[#161827]">
                    {roleItem.name}
                  </div>
                  <div className="mt-1 text-[14px] text-[#6B6F8A]">
                    {roleItem.description ?? ""}
                  </div>
                </div>
              </button>
            );
          })
        )}
      </ModalBody>

      <ModalFooter className="justify-end gap-4">
        <Button
          variant="ghost"
          className="h-11 rounded-[14px] px-6 text-[#2C2F44]"
          onClick={() => onOpenChange(false)}
        >
          Cancel
        </Button>
        <Button
          className="h-11 rounded-[14px] px-6"
          onClick={() => onOpenChange(false)}
        >
          Save roles
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default RolesSelectionModal;
